export function playSynthesizedSound(choice) {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    const ctx = new AudioContext();
    const now = ctx.currentTime;
    
    if (choice === 1) {
      // Som 1: "Toque de Telefone Clássico" (Longo e repetitivo)
      // Duração: ~2.5 segundos (6 toques rápidos)
      const repeatCount = 6;
      for (let i = 0; i < repeatCount; i++) {
        const osc1 = ctx.createOscillator();
        const osc2 = ctx.createOscillator();
        const gain = ctx.createGain();
        
        osc1.connect(gain);
        osc2.connect(gain);
        gain.connect(ctx.destination);
        
        // Frequências clássicas de telefone (ringtone dual)
        osc1.frequency.value = 440;
        osc2.frequency.value = 480;
        osc1.type = 'square';
        osc2.type = 'square';
        
        const startTime = now + (i * 0.4);
        const stopTime = startTime + 0.25;
        
        gain.gain.setValueAtTime(0, startTime);
        gain.gain.linearRampToValueAtTime(0.05, startTime + 0.02);
        gain.gain.setValueAtTime(0.05, stopTime - 0.02);
        gain.gain.linearRampToValueAtTime(0, stopTime);
        
        osc1.start(startTime);
        osc2.start(startTime);
        osc1.stop(stopTime);
        osc2.stop(stopTime);
      }
      
    } else if (choice === 2) {
      // Som 2: "Campainha Musical" (Melodia mais longa e inconfundível)
      // Duração: ~2.5 segundos
      const melody = [
        { f: 523.25, t: 0, d: 0.3 },   // C5
        { f: 659.25, t: 0.3, d: 0.3 }, // E5
        { f: 783.99, t: 0.6, d: 0.3 }, // G5
        { f: 1046.50, t: 0.9, d: 0.3 },// C6
        { f: 783.99, t: 1.2, d: 0.3 }, // G5
        { f: 659.25, t: 1.5, d: 0.8 }  // E5 mais longo no final
      ];
      
      melody.forEach(note => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        
        osc.type = 'sine';
        osc.frequency.value = note.f;
        
        gain.gain.setValueAtTime(0, now + note.t);
        gain.gain.linearRampToValueAtTime(0.3, now + note.t + 0.05);
        gain.gain.exponentialRampToValueAtTime(0.001, now + note.t + note.d);
        
        osc.start(now + note.t);
        osc.stop(now + note.t + note.d + 0.5);
      });
      
    } else if (choice === 3) {
      // Som 3: "Alarme/Sirene de Atenção" (Repetitivo e longo)
      // Duração: 3 segundos
      const repeatCount = 3;
      for (let i = 0; i < repeatCount; i++) {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        
        // Sawtooth tem muito mais presença/brilho
        osc.type = 'sawtooth'; 
        
        // Sobe a frequência de grave para agudo simulando uma sirene
        const startTime = now + (i * 1.0);
        const stopTime = startTime + 0.7; 
        
        osc.frequency.setValueAtTime(500, startTime);
        osc.frequency.linearRampToValueAtTime(1000, stopTime);
        
        // Filtro para não ficar estridente no ouvido
        const filter = ctx.createBiquadFilter();
        filter.type = 'lowpass';
        filter.frequency.value = 1500;
        
        osc.connect(filter);
        filter.connect(gain);
        gain.connect(ctx.destination);
        
        gain.gain.setValueAtTime(0, startTime);
        gain.gain.linearRampToValueAtTime(0.15, startTime + 0.1);
        gain.gain.exponentialRampToValueAtTime(0.01, stopTime);
        
        osc.start(startTime);
        osc.stop(stopTime);
      }
    }
  } catch (e) {
    console.error('Falha ao tocar som sintetizado:', e);
  }
}
